export default __webpack_public_path__ + "static/media/2.10df770f.jpg";